import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/b2c', request)
}

export {get}
